'use client';

import { twMerge } from 'tailwind-merge';
import { TabItem } from '@app/infrastructure/application/model/TabItem';
import { TabsList } from './TabsList';
import { TabsContent } from './TabsContent';
import { TabsContextProvider } from '@app/app/_context/TabsContext/TabsContextProvider';

interface Props {
    className?: string;
    contentClassName?: string;
    content: TabItem[];
    variant?: 'card' | 'underline';
    'aria-label'?: string;
    defaultActiveId?: string;
}

export function Tabs({
    className,
    contentClassName,
    content,
    variant = 'card',
    'aria-label': ariaLabel,
    defaultActiveId,
}: Props) {
    const initialTabId = defaultActiveId || content[0].id;

    return (
        <TabsContextProvider defaultTabId={initialTabId}>
            <div className={twMerge('flex flex-col', className)}>
                <TabsList content={content} variant={variant} ariaLabel={ariaLabel} />
                <TabsContent content={content} contentClassName={contentClassName} />
            </div>
        </TabsContextProvider>
    );
}
